import { EntityFilterRestriction } from "src/pages/EntityFiltersPage/EntityList/types";
import { ZUid } from "src/types/zUid";

/**
 * Ограничение списка экземпляров «только ссылающиеся на текущий экземпляр».
 *
 * ВНИМАНИЕ: механизм filterRestrictions превращается в hierarchicalFilter с
 * `toSearch: [filterValueStr]` (см. withFilterRestriction), а его штатные потребители
 * (ссылка из меню, матрица BOM3) передают ИМЯ значения справочного атрибута.
 * Здесь передаётся id экземпляра, поэтому фильтр работает только если
 * `POST /v2/values/search` для атрибута типа OBJECT_ID возвращает в `toSearch`
 * идентификатор экземпляра, а не его отображаемое имя. Требует подтверждения
 * контракта на бэкенде; если это не так, ограничение нужно переносить на сервер
 * (отдельный параметр в EntityFilters), а не собирать hierarchicalFilter на клиенте.
 */
export const makeBacklinkFilterRestriction = (
  backlinkAttributeId?: ZUid | null,
  entityId?: ZUid | null,
): EntityFilterRestriction | undefined => {
  if (!backlinkAttributeId || !entityId) {
    return undefined;
  }
  return {
    filterAttrId: backlinkAttributeId,
    filterValueStr: String(entityId),
  };
};
